import { render, staticRenderFns } from "./TheTextEditor.vue?vue&type=template&id=9ead3ae2&"
import script from "./TheTextEditor.vue?vue&type=script&lang=js&"
export * from "./TheTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./TheTextEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
